export default __webpack_public_path__ + "static/media/Japan_Particle_0002_Aka_Claw.dd483468.png";